// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__241cq","tab":"ProcedureTabs_tab__133lk"};